/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import { components } from 'react-select';

import { Typo } from 'uikit/content';
import { Avatar } from 'uikit/avatars';

import getGroupsMembersText from '../helpers/getGroupsMembersText';

import styles from '../styles/exceedGroupsCustomMenu.module.scss';

const ExceedGroupsCustomMenu = (props) => {
  const { value } = props;
  const { metadata } = value;

  const {
    avatar = value.avatar || value.avatar_path,
    code,
    eligibleMembers = value.eligibleMembers || metadata?.number_of_eligible_members,
    jobTitle = value.jobTitle || metadata?.job_title,
    membersCount = value.membersCount ?? metadata?.number_of_members,
    name,
    type,
  } = value;

  const membersText = getGroupsMembersText(eligibleMembers, membersCount);

  return (
    <components.Option {...props}>
      <div className={styles.menuElement}>
        <div className={styles.menuAvatarWrap} data-testid="exceed-groups-menu-avatar">
          <Avatar avatar={avatar} size="medium" showInitials={!avatar} name={name} />
          <div className={styles.menuUserInfo}>
            <Typo element="span" title={name} variant="s02" weight="medium">
              {name}
            </Typo>
            <div className={styles.menuMetadata}>
              <div className={styles.countWrap}>
                {type === 'user' && jobTitle && (
                  <Typo
                    color="secondary"
                    element="span"
                    title={jobTitle}
                    variant="s01"
                    className={styles.membersCount}
                  >
                    {jobTitle}
                  </Typo>
                )}
                {type === 'group' && (
                  <Typo
                    color="secondary"
                    element="span"
                    variant="s01"
                    className={styles.membersCount}
                  >
                    {membersText}
                  </Typo>
                )}
              </div>
              {code && (
                <div className={styles.codeWrap} data-testid="exceed-groups-menu-code">
                  <Typo
                    color="secondary"
                    element="span"
                    title={code}
                    variant="s01"
                    className={styles.code}
                  >
                    {code}
                  </Typo>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </components.Option>
  );
};

ExceedGroupsCustomMenu.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.shape({
      avatar_path: PropTypes.string,
      code: PropTypes.string,
      metadata: PropTypes.shape({
        job_title: PropTypes.string,
        number_of_eligible_members: PropTypes.string,
        number_of_members: PropTypes.number,
      }),
      name: PropTypes.string,
      type: PropTypes.oneOf(['group', 'user']),
    }),
    PropTypes.shape({
      avatar: PropTypes.string,
      code: PropTypes.string,
      eligibleMembers: PropTypes.string,
      jobTitle: PropTypes.string,
      membersCount: PropTypes.number,
      name: PropTypes.string,
      type: PropTypes.oneOf(['group', 'user']),
    }),
  ]).isRequired,
};

export default ExceedGroupsCustomMenu;
